// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__24rTx","list":"styles_list__23OYf"};